import _extends from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var AdConfigContext = /*#__PURE__*/React.createContext(null);
if (false) AdConfigContext.displayName = "AdConfigContext";
export function AdProvider(props) {
  var children = props.children,
    config = props.config;
  var value = React.useMemo(function () {
    return _extends({
      GADisplayRatio: 0.1
    }, config);
  }, [config]);
  return /*#__PURE__*/_jsx(AdConfigContext.Provider, {
    value: value,
    children: children
  });
}
export function useAdConfig() {
  var config = React.useContext(AdConfigContext);
  if (!config) {
    throw new Error('Could not find docs ad config context value; please ensure the component is wrapped in a <AdProvider>');
  }
  return config;
}